var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgFastFood = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    id: "Fast-Food-Burger--Streamline-Ultimate",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Fast Food Burger Streamline Icon: https://streamlinehq.com")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M2 11.5h20s2 0 2 2v0.5s0 2 -2 2H2s-2 0 -2 -2v-0.5s0 -2 2 -2",
    fill: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22 17.5a0.5 0.5 0 0 1 0.5 0.5v0.5a2 2 0 0 1 -2 2h-17a2 2 0 0 1 -2 -2V18a0.5 0.5 0 0 1 0.5 -0.5Z",
    fill: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 3.5H8a6.5 6.5 0 0 0 -6.48 6A0.5 0.5 0 0 0 2 10h20a0.5 0.5 0 0 0 0.5 -0.54A6.5 6.5 0 0 0 16 3.5ZM7.5 7a1 1 0 1 1 1 -1 1 1 0 0 1 -1 1ZM12 8.5a1 1 0 1 1 1 -1 1 1 0 0 1 -1 1ZM16.5 7a1 1 0 1 1 1 -1 1 1 0 0 1 -1 1Z",
    fill: "currentColor",
    strokeWidth: 1
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgFastFood);
export default ForwardRef;